import { render, staticRenderFns } from "./material-receive-list.vue?vue&type=template&id=3ba278cd&scoped=true&"
import script from "./material-receive-list.vue?vue&type=script&lang=js&"
export * from "./material-receive-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba278cd",
  null
  
)

export default component.exports